import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { GeoAltFill } from 'react-bootstrap-icons';

class OptometristClues extends Component {
    render() {
        const popover = (
            <Popover className="popover-basic">
                <Popover.Title as="h3">Optometrist Clue</Popover.Title>
                <Popover.Content>
                    <img src="https://res.cloudinary.com/dqykhzxtl/image/upload/v1603263311/virtual-time-travel/Optometrist_Chart_gyr7cx.jpg" className="popover-images" alt="Optometrist Clues" />
                </Popover.Content>
            </Popover>
        );

        return (
            <OverlayTrigger
                trigger="click"
                placement="auto"
                overlay={popover}
                rootClose={true}
                transition={false}
                onToggle={() => this.setState({ error: null })}
            >
                <div className="game-icons" style={this.props.positioning}>
                    <GeoAltFill alt="Optometrist Clues" />
                </div>
            </OverlayTrigger>
        )
    }
}

export default OptometristClues;
